import {
  FETCH_FILES_FROM_BUCKET_REQUEST,
  FETCH_FILES_FROM_BUCKET_SUCCESS,
  FETCH_FILES_FROM_BUCKET_FAILED,
  RESET_UPLOAD_AND_SCAN,
  ADD_FILES_TO_UPLOAD_LIST,
  CHANGE_FILE_TO_UPLOAD,
  SET_SELECTED_FILE,
  SELECT_ALL_FILES,
  SET_HIERARCHY,
  DELETE_FILES_SUCCESS,
  RESET_FILES_TO_UPLOAD,
  POST_EXPORT_FILES_SUCCESS,
  RESET_EXPORT_FILES,
} from './actionTypes';
import { toggleSelected } from '../../core/helpers/default';

const initialState = {
  loading: true,
  files: [],
  selectedFilesIds: [],
  meta: {
    last_page: 1,
    search: '',
    per_page: 100,
    current_page: 1,
  },
  filesToUpload: [],
  hierarchy: [{ id: null, name: 'Files' }],
  generatedCSV: null,
};

const uploadAndScanReducer = (
  state = initialState,
  {
    type,
    files,
    meta,
    id,
    selectAll,
    filesToUpload,
    fileToUpload,
    hierarchy,
    generatedCSV,
  },
) => {
  switch (type) {
    case FETCH_FILES_FROM_BUCKET_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_FILES_FROM_BUCKET_SUCCESS:
      return {
        ...state,
        loading: false,
        files: files.map((f) => ({ ...f, _selected: state.selectedFilesIds.includes(f.id) })),
        meta,
      };
    case FETCH_FILES_FROM_BUCKET_FAILED:
      return {
        ...state,
        loading: false,
      };
    case ADD_FILES_TO_UPLOAD_LIST:
      return {
        ...state,
        filesToUpload: [...state.filesToUpload, ...filesToUpload],
      };
    case CHANGE_FILE_TO_UPLOAD:
      return {
        ...state,
        filesToUpload: state.filesToUpload.map((f) =>
          f.name === fileToUpload.name && f.status !== 'completed' ? fileToUpload : f,
        ),
      };
    case RESET_FILES_TO_UPLOAD:
      return {
        ...state,
        filesToUpload: [],
      };
    case SET_HIERARCHY:
      return {
        ...state,
        loading: true,
        hierarchy,
        meta: {
          ...state.meta,
          current_page: 1,
        },
      };
    case SET_SELECTED_FILE:
      return {
        ...state,
        selectedFilesIds: toggleSelected(state.selectedFilesIds, id),
        files: state.files.map((i) => (id === i.id ? { ...i, _selected: !i._selected } : i)),
      };
    case SELECT_ALL_FILES:
      return {
        ...state,
        selectedFilesIds: selectAll ? state.files.map((f) => f.id) : [],
        files: state.files.map((i) => ({ ...i, _selected: selectAll })),
      };
    case DELETE_FILES_SUCCESS:
      return {
        ...state,
        selectedFilesIds: [],
      };
    case POST_EXPORT_FILES_SUCCESS:
      return {
        ...state,
        generatedCSV,
      };
    case RESET_EXPORT_FILES:
      return {
        ...state,
        generatedCSV: null,
      };
    case RESET_UPLOAD_AND_SCAN:
      return initialState;
    default:
      return state;
  }
};

export default uploadAndScanReducer;
